import { render } from "./BaseContainer.vue?vue&type=template&id=9d349ff6"
const script = {}

import "./BaseContainer.vue?vue&type=style&index=0&id=9d349ff6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__